"use client";
import { Button, Image, Text, Tooltip } from "@mantine/core";
import styles from "./jobCardCustom.module.scss";
import variables from "../../../styles/variables.module.scss";
import useTrans from "@/hooks/useTrans";
import { useEffect, useState } from "react";
import { getMasterdata } from "@/services/services";
import { LocalStorageKey } from "@/services/constants";
import { useWindowSize } from "usehooks-ts";

export default function JobCardCustom({
  recruitmentPlan,
  onBtnClick,
  cardStyle,
  showButton = true,
  buttonLabel,
}) {
  const isMobile = useWindowSize().width < 768;
  const [descItems, setDescItems] = useState([]);

  const cardWrapperStyle = {
    padding: 24,
    borderWidth: "1.25px",
    borderStyle: "solid",
    borderRadius: 8,
    cursor: "pointer",
    width: "100%",
    backgroundColor: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    "--border-color": "#d9d9e1",
    "--hover-border-color": variables.primaryColor,
  };

  const contentWrapperStyle = {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    header: {
      fontSize: 20,
      fontWeight: 700,
      lineHeight: "28px",
      color: variables.primaryColor,
    },
    descItemsWrapper: {
      display: "flex",
      flexDirection: "column",
      gap: 8,
      item: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        text: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: "24px",
        },
      },
    },
  };

  const buttonWrapperStyle = {
    button: {
      backgroundColor: variables.primaryColor,
      borderRadius: 4,
    },
  };

  useEffect(() => {
    const processItems = async () => {
      if (recruitmentPlan && recruitmentPlan.descItems) {
        const tempItems = await Promise.all(
          recruitmentPlan.descItems.map(async (descItem) => {
            let tempValue = descItem.value;

            if (descItem.isMasterdata) {
              const valueSplit = descItem.value.map((i) => {
                return i.split(":")[2];
              });

              const oldTenant = localStorage.getItem(LocalStorageKey.TENANT);

              let hostNameUrl = window.location.host;
              if (oldTenant) {
                const oldUrl = localStorage.getItem(oldTenant);
                hostNameUrl = oldUrl ?? window.location.host;
              }

              tempValue = await getMasterdata(
                hostNameUrl,
                descItem.masterdata,
              ).then((res) => {
                return res
                  .filter(
                    (i) =>
                      valueSplit.length > 0 && valueSplit.includes(i.value),
                  )
                  .map((i) => i.label);
              });
              if (tempValue.length == 0) {
                tempValue = descItem.defaultValue;
              }
            }
            return {
              icon: descItem.icon,
              value: tempValue,
            };
          }),
        );

        setDescItems(tempItems);
      }
    };

    processItems();
  }, [recruitmentPlan]);

  useEffect(() => {
    if (!Array.isArray(descItems)) {
      setDescItems([]);
    }
  }, [descItems]);

  const trans = useTrans();
  // const isThreshold = useMediaQuery(`(max-width:${threshold || 768}px`);
  return (
    <div
      className={styles.cardContainer}
      style={{
        ...cardWrapperStyle,
        ...(cardStyle || {}),
      }}
    >
      <div
        style={{
          ...contentWrapperStyle,
          ...(cardStyle?.contentWrapperStyle || {}),
        }}
      >
        <Tooltip withArrow label={recruitmentPlan.name}>
          <Text
            style={{
              ...contentWrapperStyle.header,
              ...(cardStyle?.contentWrapperStyle?.header || {}),
            }}
            lineClamp={4}
          >
            {recruitmentPlan.name}
          </Text>
        </Tooltip>
        <div
          style={{
            ...contentWrapperStyle.descItemsWrapper,
            ...(cardStyle?.contentWrapperStyle?.descItemsWrapper || {}),
          }}
        >
          {descItems.map((item, idx) => (
            <div
              key={idx}
              style={{
                ...contentWrapperStyle.descItemsWrapper.item,
                ...(cardStyle?.contentWrapperStyle?.descItemsWrapper?.item ||
                  {}),
              }}
            >
              <Image
                alt="icon dollar"
                src={`${process.env.NEXT_PUBLIC_BASE_PATH
                  ? `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/${item.icon}.svg`
                  : `/icons/${item.icon}.svg`
                  }`}
                width={16}
                height={16}
              />
              <Text
                style={{
                  ...contentWrapperStyle.descItemsWrapper.item.text,
                  ...(cardStyle?.contentWrapperStyle?.descItemsWrapper?.item
                    ?.text || {}),
                }}
                lineClamp={
                  cardStyle?.contentWrapperStyle?.descItemsWrapper?.item
                    ?.lineClamp || 1
                }
              >
                {Array.isArray(item.value)
                  ? item.value.toString().replace(",", ", ")
                  : item.value}
              </Text>
            </div>
          ))}
        </div>
      </div>
      {showButton && (
        <div
          style={{
            ...buttonWrapperStyle,
            ...(cardStyle?.buttonWrapperStyle || {}),
          }}
        >
          <Button
            style={{
              ...buttonWrapperStyle.button,
              ...(cardStyle?.buttonWrapperStyle?.button || {}),
            }}
            radius={"md"}
            onClick={onBtnClick}
          >
            {buttonLabel ?? trans.jobDetail}
          </Button>
        </div>
      )}
    </div>
  );
}
